var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row align-center"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-menu")]),_c('img',{staticClass:"gallery-img",attrs:{"src":_vm.fullurl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }